export enum Sorting {
  ASC = "ASC",
  DESC = "DESC",
}
